import React from 'react';
import { useParams } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ProductDetailHero } from '../components/merch/ProductDetailHero';
import { getProductById } from '../data/products';
export function ProductDetailPage() {
  const {
    productId
  } = useParams<{
    productId: string;
  }>();
  const product = productId ? getProductById(productId) : undefined;
  if (!product) {
    return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-845">
        <Header data-id="element-846" />
        <main className="pt-20" data-id="element-847">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center" data-id="element-848">
            <h1 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-849">
              Product Not Found
            </h1>
            <p className="text-slate-600" data-id="element-850">
              The product you're looking for doesn't exist.
            </p>
          </div>
        </main>
        <Footer data-id="element-851" />
      </div>;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-852">
      <Header data-id="element-853" />

      <main className="pt-20" data-id="element-854">
        <ProductDetailHero product={product} data-id="element-855" />
      </main>

      <Footer data-id="element-856" />
    </div>;
}